import { MusicPaperContractConfigurationServiceClientConfigFactory } from '@amzn/coral-config_music-paper-contract-configuration-service';
import {
    MusicPaperContractConfigurationService,
    musicPaperContractConfigurationServiceHttpBindingInterceptor
} from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';
import {
    CoralClientFactory,
    CoralFetchHandler,
    CoralHandler,
    CoralRequest,
    InterceptingHandler
} from '@amzn/ihm-js-coral-client';
import { Aws4HmacSha256Interceptor } from '@amzn/ihm-js-coral-client';

import { Auth } from 'aws-amplify';
import { getStage } from 'src/util/config';
import { getUserConfig } from 'src/util/config';

import AuxiliaryRequestInterceptor from './AuxiliaryRequestInterceptor';

const getQualifier = () => {
    switch (getStage()) {
        case 'test':
        case 'beta':
            return 'Base.IAD.Beta';
        case 'gamma':
            return 'Base.IAD.Gamma';
        case 'prod':
            return 'Base.IAD.Prod';
        default:
            return 'Base.IAD.Beta';
    }
};

const sigV4Interceptor = new Aws4HmacSha256Interceptor(async () => {
    const credentials = await Auth.currentCredentials();

    return {
        accessKeyId: credentials.accessKeyId,
        secretAccessKey: credentials.secretAccessKey,
        sessionToken: credentials.sessionToken
    };
});

const usePersonalStack = getStage() === 'personal';

const baseInterceptors = [
    musicPaperContractConfigurationServiceHttpBindingInterceptor,
    new AuxiliaryRequestInterceptor(),
    sigV4Interceptor
];

const personalStackInterceptor = usePersonalStack
    ? [
          {
              intercept: (request: CoralRequest, next: CoralHandler) => {
                  return next.handle(
                      request.clone({
                          url: getUserConfig().apiEndpoint
                      })
                  );
              }
          }
      ]
    : [];

const clientFactory = new CoralClientFactory(
    [MusicPaperContractConfigurationServiceClientConfigFactory],
    getQualifier(),
    new InterceptingHandler(new CoralFetchHandler(), baseInterceptors),
    personalStackInterceptor
);

export const contractConfigurationClient = clientFactory.get(MusicPaperContractConfigurationService);
